import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { oneOf, oneOfType, arrayOf, node } from 'prop-types';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { HEADING_VARIANTS, HEADING_LEVELS } from './constants.js';
export { HEADING_LEVELS, HEADING_VARIANTS } from './constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
const Heading = /*#__PURE__*/styled.h1.withConfig({
  displayName: "heading__Heading",
  componentId: "sc-5w1f6q-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // For consistency since all headings have a default display block but label doesn't\n  display: block;\n  margin: 0;\n  margin-block-end: ", ";\n  font-family: ", ";\n  line-height: ", ";\n  font-weight: bold;\n\n  [dir='rtl'] & {\n    font-family: ", ";\n    line-height: ", ";\n    text-transform: none;\n  }\n\n  color: ", ";\n\n  ", "\n\n  ", "\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.threeQuarterSpacing;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.fonts.heading;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.lineHeights.heading;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.rtlFonts.heading;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.rtlLineHeights.heading;
}, _ref6 => {
  let {
    theme: {
      colors
    }
  } = _ref6;
  return theme('mode', {
    light: colors.primary.dark,
    dark: colors.primary.main
  });
}, _ref7 => {
  let {
    theme: {
      colors
    }
  } = _ref7;
  return theme('name', {
    pureGym: "text-transform: uppercase;",
    fitnessWorld: "color: ".concat(colors.text, ";")
  });
}, _ref8 => {
  let {
    theme: {
      mediaQueries
    },
    variant
  } = _ref8;
  switch (variant) {
    case HEADING_VARIANTS.ALPHA:
      {
        return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          font-size: 2.8rem;\n\n          ", " {\n            font-size: 3.8rem;\n          }\n        "])), mediaQueries.md);
      }
    case HEADING_VARIANTS.BETA:
      {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          font-size: 2.4rem;\n\n          ", " {\n            font-size: 2.8rem;\n          }\n        "])), mediaQueries.md);
      }
    case HEADING_VARIANTS.GAMMA:
      {
        return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          font-size: 2.1rem;\n\n          ", " {\n            font-size: 2.4rem;\n          }\n        "])), mediaQueries.md);
      }
    case HEADING_VARIANTS.DELTA:
      {
        return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          font-size: 1.6rem;\n\n          ", " {\n            font-size: 2.1rem;\n          }\n        "])), mediaQueries.md);
      }
    case HEADING_VARIANTS.EPSILON:
      {
        return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          font-size: 1.6rem;\n          font-style: normal;\n          text-transform: none;\n        "])));
      }
    case HEADING_VARIANTS.ZETA:
      {
        return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          font-size: 1.4rem;\n          font-style: normal;\n          text-transform: none;\n        "])));
      }
    // no default
  }
});

Heading.propTypes = {
  as: oneOf(Object.values(HEADING_LEVELS)),
  variant: oneOf(Object.values(HEADING_VARIANTS)),
  children: oneOfType([arrayOf(node), node]).isRequired
};
Heading.defaultProps = {
  variant: HEADING_VARIANTS.ALPHA
};

export { Heading };
